type BrandLogoProps = {
  compact?: boolean;
};

export function BrandLogo({ compact = false }: BrandLogoProps) {
  return (
    <a className="brand-logo" href="#top" aria-label="BlockRazor MCP home">
      <img src="/blockrazor-logo.png" alt="BlockRazor" />
      {!compact && <span>Developer MCP</span>}
    </a>
  );
}
